import { envConfigs } from '../../../envConfigs';
import { handleServiceCall } from './fetch-utils';

// https://stackoverflow.com/questions/1423195/what-is-the-actual-minimum-length-of-an-email-address-as-defined-by-the-ietf
const MINIMUM_EMAIL_LENGTH = 6; // a@b.cd

// If this ever changes, update the corresponding REGEX in AdminTools, and verify it's consistent
// with validateEmailAddress() in Ego.
var EMAIL_REGEX = /^((([-_A-Zäöüéèæÿûùa-z0-9-+.%!']+\.%!')*[-_A-Zäöüéèæÿûùa-z0-9-+.%!']+.%!')|[-_A-Zäöüéèæÿûùa-z0-9+.%!']+)@(?:[A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z]{2,20}$/;

export const isValidEmail = (emailAddress) => {
  if(!emailAddress || emailAddress.length < MINIMUM_EMAIL_LENGTH) {
    return false;
  }
  const testResult = EMAIL_REGEX.test(emailAddress);
  return testResult;
};

export const deliverEmail = (email, userInfo, trigger, token, isSSO, product) => {
  const postObject = {
    email: {
      email: email,
      user_guid: userInfo.gui,
      service: 'Sendgrid',
      trigger: trigger
    },
    // These are the attributes that are injected into the Sendgrid email template
    attributes: {
      localizationLanguage: userInfo.interfaceLanguage,
      namespace: userInfo.namespace,
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      isSSO: isSSO,
      product: product
    }
  };
  const postString = JSON.stringify(postObject);
  //{"email":{"email":"pparm@els.test","user_guid":"f38b2eb6-d5c4-422d-a9f3-6f28b79cb3f8","service":"Sendgrid","trigger":"MobileAppFoundationsTrigger"},"attributes":{"localizationLanguage":"en-US","namespace":"els","firstName":"Posy","lastName":"Parm"}}
  const emailUrl = envConfigs.emailApiHost + '/api/email/deliver';
  return fetch(emailUrl, {
    method: 'POST',
    body: postString,
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};



// WEBPACK FOOTER //
// ./src/modules/app/util/email-helper.js